import { render, staticRenderFns } from "./JobItemForm.vue?vue&type=template&id=375513c4&"
import script from "./JobItemForm.vue?vue&type=script&lang=js&"
export * from "./JobItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports